import { Page } from "@/libs/model/common/index";
/**后备人才ID */
export class TrainingBaseId {
  constructor() {
    this.trainingBaseId = "";
  }
}

/**后备人才ID数组 */
export class BatchTrainingBaseId {
  constructor() {
    this.trainingBaseId = [];
  }
}

/**新增和更新后备人才(旧) */
export class TrainingBaseVO {
  constructor() {
    /**详细地址 */
    this.address = "";
    /**城市 */
    this.city = "";
    /**联系人 */
    this.contactPerson = "";
    /**联系方式 */
    this.contactPhone = "";
    /**经费 */
    this.funds = "";
    /**邮箱 */
    this.mail = "";
    /*名称 */
    this.name = "";
    /**所属单位 -- 系统管理员必须上传,其余不用上传 */
    this.orgId = "";
    /**省份 */
    this.province = "";

    this.trainingBaseId = "";
    this.cultivateBaseCode = "";
    this.countryFunds = "";
    this.provinceFunds = "";
    this.orgBaseId = "";
  }
}

/**新增和更新后备人才(新) */
export class TrainingBaseNewVO {
  constructor() {
    /**所属单位 -- 系统管理员必须上传,其余不用上传 */
    this.orgId = "";
    /**项目 */
    this.otherPlanDictItem1Id = "";
    /**省份 */
    this.otherPlanDictItem2Id = "";
    /*体校名称 */
    this.name = "";
    /**详细地址 */
    this.address = "";
    /**总局拨付经费 */
    this.countryFunds = "";
    /**省市配套经费 */
    this.provinceFunds = "";
    /**总经费 */
    this.funds = "";
    /**联系人 */
    this.contactPerson = "";
    /**联系方式 */
    this.contactPhone = "";
    /**邮箱 */
    this.mail = "";
    /**修改的ID */
    this.otherPlanId = "";
  }
}

/**查询后备人才分页列表 */
export class BasePageListVO extends Page {
  constructor() {
    super();
    this.approveStatus = "";
    this.discipline = "";
    this.name = "";
    this.province = "";
    this.year = "";
    this.type = "";
  }
}
